module.exports = __webpack_public_path__ + "static/img/1.f2683bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/1.png
// module id = GDIL
// module chunks = 0